import { Button, ButtonRow } from '@ksyos/design-system';
import type { IQuestionnaireFormProps } from '../../../Questionnaire';
import type { IHsdqQuestion } from '../NewHsdqQuestionnaire';
import { hsdqQuestionOptions } from '../../../../../../../common/validation/customControls/somnology';
import { Step } from '../../../../../elements/atoms/step/Step';
import { CustomContainer } from '../../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../../elements/molecules/stack/Stack';
import { PageIntro } from '../../../../../elements/organisms/pageIntro/PageIntro';
import { QuestionnaireRadioGroup } from '../../../../../elements/organisms/questionnaireRadioGroup/QuestionnaireRadioGroup';
import { StyledFormGroup } from '../../../../../elements/organisms/StyledFormGroup/StyledFormGroup';

export function Step5(props: IQuestionnaireFormProps) {
    const questions: IHsdqQuestion[] = [
        {
            key: 'functionLessWell',
            label: 'Omdat ik te weinig slaap krijg, functioneer ik overdag minder goed',
            number: 21,
        },
        {
            key: 'sometimesInjured',
            label: 'Ik heb mezelf tijdens mijn slaap wel eens verwond, zonder me dat achteraf te herinneren',
            number: 22,
        },
        {
            key: 'fallAsleepRepeatedly',
            label: 'In de loop van de dag val ik herhaaldelijk in slaap',
            number: 23,
        },
        {
            key: 'confusedHalfAwake',
            label: 'Ik word regelmatig verward halfwakker en maak dan slaande bewegingen. Ik herinner mij er later vrijwel niets van',
            number: 24,
        },
        {
            key: 'iDontFeelRestedAfterNap',
            label: 'Na een dutje overdag voel ik me niet uitgerust',
            number: 25,
        },
    ];

    return (
        <>
            <PageIntro title="HSDQ: vragen deel 5/7" />

            <CustomContainer>
                {questions.map((question) => {
                    return (
                        <Stack key={question.key}>
                            <Step>{question.number}/32</Step>
                            <StyledFormGroup
                                hasErrors={props.errors.has(question.key)}
                                label={question.label}
                                layout="vertical"
                            >
                                <QuestionnaireRadioGroup
                                    {...props}
                                    customControlData={props.procedure.customControlData}
                                    customControlKey={question.key}
                                    questionnaireOptions={hsdqQuestionOptions}
                                />
                            </StyledFormGroup>
                        </Stack>
                    );
                })}

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                        width="full-below-small"
                    >
                        Verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
